import { Box, Image, UnstyledButton } from "@dehub/theme";
import { HouseLineIcon } from "@phosphor-icons/react";
import { renderBusinessName } from "@/utils/render-business-name";
import classes from "../branch.module.css";

type Props = Readonly<{
  logo?: string | null;
  name?: string | null;
  nameEng?: string | null;
  onPreview?: (src: string, name: string) => void;
}>;

/** Square branch logo; a house icon when there is none (the drawer says the organization logo applies). */
export function BranchLogo({ logo, name, nameEng, onPreview }: Props) {
  const display = renderBusinessName({ profileName: name, profileNameEng: nameEng });

  if (logo && onPreview) {
    return (
      <UnstyledButton className={classes.logoImage} aria-label={display} onClick={() => onPreview(logo, display)}>
        <Image src={logo} alt="" w="100%" h="100%" fit="cover" />
      </UnstyledButton>
    );
  }
  if (logo) {
    return (
      <Box className={classes.logoImage}>
        <Image src={logo} alt="" w="100%" h="100%" fit="cover" />
      </Box>
    );
  }
  return (
    <Box className={classes.typeIcon} aria-hidden="true">
      <HouseLineIcon size={16} />
    </Box>
  );
}
